import { docReady } from "./utils";
import preloaderInit from "./preloader";
import detectorInit from "./detector";
import tooltipInit from "./tooltip";
import popoverInit from "./popover";
import toastInit from "./toast";
import navbarInit from "./navbar";
import plyrInit from "./plyr";
import initMap from "./googleMap";
import countupInit from "./countup";
import isotopeInit from "./isotope";
import typedTextInit from "./typed";
import formInit from "./form-processor";
import rellaxInit from "./rellax";
import bigPictureInit from "./bigPicture";
import dropdownOnHover from "./dropdown-on-hover";
import dropdownMenuInit from "./dropdown-menu";
import glightboxInit from "./lightbox";
import bgPlayerInit from "./bg-player";
import zanimationInit from "./zanimation";
import inertiaInit from "./inertia";
import tableCollationInit from "./basic-table";

/* -------------------------------------------------------------------------- */
/*                            Theme Initialization                            */
/* -------------------------------------------------------------------------- */
docReady(preloaderInit);
docReady(detectorInit);
docReady(tooltipInit);
docReady(popoverInit);
docReady(toastInit);
docReady(navbarInit);
docReady(plyrInit);
docReady(initMap);
docReady(countupInit);
docReady(isotopeInit);
docReady(typedTextInit);
docReady(formInit);
docReady(rellaxInit);
docReady(bigPictureInit);
docReady(dropdownOnHover);
docReady(dropdownMenuInit);
docReady(glightboxInit);
docReady(bgPlayerInit);
docReady(zanimationInit);
docReady(inertiaInit);
docReady(tableCollationInit);
